import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NbButtonModule, NbCardModule, NbDialogRef, NbIconModule, NbInputModule } from '@nebular/theme';

@Component({
  selector: 'app-ngx-confirm-modal',
  templateUrl: './ngx-confirm-modal.component.html',
  styleUrls: ['./ngx-confirm-modal.component.css'],
  imports: [NbCardModule, NbIconModule, NbButtonModule, NbInputModule, FormsModule]
})
export class NgxConfirmModalComponent implements OnInit {
  public title = '';
  public message = '';
  public yesButton = $localize`Save`;
  public noButton = $localize`Cancel`;
  public userInput = '';

  constructor(protected ref: NbDialogRef<NgxConfirmModalComponent>) {}

  public ngOnInit() {}

  public clickedYes() {
    this.ref.close(true);
  }

  public clickedNo() {
    this.ref.close(false);
  }
}
